import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import DatosJuicio from './DatosJuicio'
import InstruccionesJuicio from './InstruccionesJuicio'
import ObservacionJuicio from "./ObservacionJuicio"
import { Boton, Label } from 'asocomponents'
import { useNavigate } from 'react-router-dom'

export default function DetalleJuicio() {
    const usuarioString = sessionStorage.getItem("usuario") && JSON.parse(sessionStorage.getItem("usuario"))
    const cuit = usuarioString.usuario
    const idJuicioSeleccionado = useSelector(state => state.rootReducer.datosJuicio.idJuicio)
    const navigate = useNavigate()

    const [isEnabled, setIsEnabled] = useState(false)
    const [clearIdJuicio, setClearIdJuicio] = useState(false)

    const redireccionar = () => {
        navigate("/juicios")
    }
    const handleVolver = () => {
        redireccionar()
    }

    useEffect(() => {
        !isEnabled && setClearIdJuicio(!clearIdJuicio)
    }, [isEnabled])

    useEffect(() => {
        if (idJuicioSeleccionado) {
            setIsEnabled(true)
        }
    }, [isEnabled])

    return (
        <div>
            <DatosJuicio cargaHabilitada={isEnabled} idJuicio={idJuicioSeleccionado} />
            <InstruccionesJuicio cargaHabilitada={isEnabled} idJuicio={idJuicioSeleccionado}  />
            <ObservacionJuicio cargaHabilitada={isEnabled} idJuicio={idJuicioSeleccionado} cuit={cuit} />
            <div className="flex flex-col justify-center items-center mt-5">
                <div className="border-asociart-blue w-[100%]">
                    {idJuicioSeleccionado &&
                        <div className="flex justify-between items-center w-full px-10 mt-5 mb-5">
                            <div className="flex-1 flex justify-center align-middle">

                                <Boton
                                    texto="Volver"
                                    fondo="rojo"
                                    onClick={handleVolver}
                                />

                            </div>
                        </div>
                    }
                    {!idJuicioSeleccionado &&
                        <div className="flex flex-row justify-end items-center m-5 text-sm">
                            <Label texto="(*) Campos obligatorios" color="text-asociart-custom" />
                        </div>
                    }
                    <div className="flex flex-row justify-start items-center m-5 text-xs">
                        Ante cualquier duda, comunicarse con su asistente administrativo de referencia, según corresponda
                    </div>
                </div>
            </div>

        </div>
    )
}
